import React from 'react'

export function LineSeparator() {
  return <hr></hr>
}